import React from 'react'
import StructuredData from './StructuredData'

export const getQuestionData = ({ question, answer }) => {
  return {
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  }
}

export default function QuestionStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getQuestionData(data)

  return <StructuredData data={structuredData} dataTestId="question-structured-data" />
}
